import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import { Base } from './Base.js';
export var Bitfield = /*#__PURE__*/function (_Base) {
  _inherits(Bitfield, _Base);
  var _super = _createSuper(Bitfield);
  function Bitfield(type) {
    var _this;
    var flags = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    _classCallCheck(this, Bitfield);
    _this = _super.call(this);
    _this.type = type;
    _this.flags = flags;
    return _this;
  }
  _createClass(Bitfield, [{
    key: "decode",
    value: function decode(stream) {
      var val = this.type.decode(stream);
      var res = {};
      for (var i = 0; i < this.flags.length; i++) {
        var flag = this.flags[i];
        if (flag != null) {
          res[flag] = !!(val & 1 << i);
        }
      }
      return res;
    }
  }, {
    key: "size",
    value: function size() {
      return this.type.size();
    }
  }, {
    key: "encode",
    value: function encode(stream, keys) {
      var val = 0;
      for (var i = 0; i < this.flags.length; i++) {
        var flag = this.flags[i];
        if (flag != null) {
          if (keys[flag]) {
            val |= 1 << i;
          }
        }
      }
      return this.type.encode(stream, val);
    }
  }]);
  return Bitfield;
}(Base);